import { useState } from "react";
import { Box, Space } from "@gocardless/flux-react";
import { CreditorBankAccountResource } from "@gocardless/api/dashboard/types";

import AdditionalCurrencyRow from "./AdditionalCurrencyRow";

import { Currency } from "src/common/currencies";
import { Country } from "src/config";
import { MerchantOnboardingSetupEvents } from "src/components/routes/Setup/common/constants/MerchantOnboardingSetupEvents";
import AddBankForm, {
  AddBankFormVariant,
} from "src/components/routes/Setup/bank-details/forms/AddBankForm";
import BankDetailsCard from "src/components/routes/Setup/bank-details/features/bank-details-card/BankDetailsCard";
import { useSegmentForSetup } from "src/components/routes/Setup/common/hooks/useSegmentForSetup";

interface Props {
  bankDetails?: CreditorBankAccountResource;
  handleUpdate: (
    currency: Currency,
    details?: CreditorBankAccountResource
  ) => void;
  country: Country;
  currency: Currency;
}

const AdditionalCurrency: React.FC<Props> = ({
  bankDetails,
  handleUpdate,
  country,
  currency,
}) => {
  const { sendEvent } = useSegmentForSetup();
  const [showBankForm, setShowBankForm] = useState(false);

  return (
    <Box>
      {showBankForm ? (
        <AddBankForm
          variant={AddBankFormVariant.Setup}
          currency={currency}
          defaultCountry={country.code}
          details={bankDetails}
          onSubmit={(details) => {
            if (details) {
              handleUpdate(currency, details);
              sendEvent(
                MerchantOnboardingSetupEvents.BankAccountInternationalAccountAdded,
                { page_version: "variant" }
              );
            }
            setShowBankForm(false);
          }}
          onAccountDisabled={() => {
            // remove currency
            handleUpdate(currency);
            setShowBankForm(false);
          }}
        />
      ) : (
        <>
          {bankDetails ? (
            <BankDetailsCard
              accountName={bankDetails.account_holder_name ?? ""}
              accountNumberEnding={bankDetails.account_number_ending}
              bankName={bankDetails.bank_name}
              currency={currency}
              handleUpdate={() => {
                setShowBankForm(true);
              }}
            />
          ) : (
            <AdditionalCurrencyRow
              addAccount={() => {
                setShowBankForm(true);
              }}
              currency={currency}
              country={country}
            />
          )}
        </>
      )}
      <Space v={2} />
    </Box>
  );
};

export default AdditionalCurrency;
